import { Controller } from '@hotwired/stimulus'

// Drives the hero's floating-card visual in lockstep with the rotating headline.
// The `dynamic-text` controller bubbles a `dynamic-text:change` event carrying the
// current phrase index; we activate the matching scene so the picture always matches
// the words. Scene 0 is server-rendered `is-active`, so the visual still reads if this
// controller (or the headline's JS) never runs.
//
// Usage:
//   <div data-controller="hero-showcase"
//        data-action="dynamic-text:change@window->hero-showcase#show">
//     <div class="hero-showcase__scene is-active" data-hero-showcase-target="scene">…</div>
//     <div class="hero-showcase__scene"           data-hero-showcase-target="scene">…</div>
//   </div>
export default class extends Controller {
  static targets = ['scene']

  connect() {
    // Ensure exactly one scene is active even before the first headline event.
    this.activate(0)
  }

  show(event) {
    const index = event?.detail?.index
    if (typeof index !== 'number') return
    this.activate(index)
  }

  activate(index) {
    if (this.sceneTargets.length === 0) return
    // Wrap so an index beyond our scene count still lands on a real scene.
    const active = ((index % this.sceneTargets.length) + this.sceneTargets.length) %
      this.sceneTargets.length

    this.sceneTargets.forEach((scene, i) => {
      scene.classList.toggle('is-active', i === active)
    })
  }
}
